import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { NgZorroAntdModule } from '../../../modules/nz-zorro-antd.module';
import { NgZorroIconModule } from '../../../modules/nz-icon-antd.module';
import { I18nService } from '../../../services/i18n.service';
import { HeaderModule } from '../../../shared/header/header.module';
import { FooterModule } from '../../../shared/footer/footer.module';
import { UtilityService } from '../../../services/utility.service';
import { ValidationErrorsModule } from '../../../shared/validation-errors/validation-errors.module';
import { InputFieldModule } from "../../../shared/input-field/input-field.module";
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		LoginComponent
	],
	imports: [
		CommonModule,
		LoginRoutingModule,
		ReactiveFormsModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		HeaderModule,
		FooterModule,
		ValidationErrorsModule,
		InputFieldModule,
		TranslateModule
	],
	exports: [
		LoginComponent
	],
	providers: [
		I18nService,
		UtilityService
	]
})

export class LoginModule { }
